export default "__VITE_ASSET__BZLo8Bs1__"